(function() {
    'use strict';

    var $page = $('#page');
    /**
       Enhances loading.
     @param {Object} loadingDiv $ object of div that contains waiting page
     @return {Object} Returns a loading object.
     */
    Odigeo.UIElements.enhanceLoading = function(loadingDiv) {
        var $el = (loadingDiv instanceof $) ? loadingDiv : $(loadingDiv);

        var show = function(labelsArray, showAds) {
            if (showAds && $el.find('#modwaiting').length > 0) {
                Odigeo.UIElements.enhanceAdvertisementGptNonJS($el.find('#modwaiting'));
            }

            $page.addClass('waiting').attr('data-waiting', true);

            // Show labels
            Odigeo._.each($el.find('.waiting_element'), function(item) {
                $(item).addClass('odf-hidden');
            });

            Odigeo._.each(labelsArray, function(item) {
                var waitingLabel = $el.find('[data-waiting=' + item + ']');
                var additionExcludedPages = ['waiting_searching', 'waiting_intermediate_page'];
                var waitingPage;
                var indexAddition;

                waitingLabel.removeClass('odf-hidden');

                // Track analytics virtual page
                if (waitingLabel.data('pageindex')) {
                    waitingPage = waitingLabel.data('waiting');
                    var excluded = Odigeo._.some(additionExcludedPages, function(page) {
                        return waitingPage === page;
                    });

                    indexAddition = Odigeo.Session.get('intermediatePageShown') === 'true' && !excluded ? 1 : 0;
                    Odigeo.trigger('loading:show', parseInt(waitingLabel.data('pageindex'), 10) + indexAddition);
                }
            });
            $el.find('[data-counter]:visible').text(0);
            // Show waiting page and animate progressbars
            $el.removeClass('odf-hidden').stop().animate({opacity: 1}, 700, 'swing', function() {
                var bars = $el.find('.progressbar:visible');
                bars.each(function(index) {
                    $(this).one(Odigeo.Events.transitionEnd, function() {
                        $(bars[index + 1]).addClass('animate');
                    });
                }).first().addClass('animate');

                $el.find('[data-counter]:visible').trigger('startCount');

                // Disable scrolling when waiting page is visible
                $el.off().on(Odigeo.Events.touchmove, function(evt) {
                    evt.stopPropagation();
                });
            });
        };
        var hide = function() {
            $el.find('[data-counter]:visible').trigger('stopCount');
            $el
                .stop()
                .animate({opacity: 0}, 700, 'swing')
                .queue(function(next) {
                    $el.addClass('odf-hidden').find('.progressbar').removeClass('animate');

                    // Hide labels
                    Odigeo._.each($el.find('.waiting_element'), function(item) {
                        $(item).addClass('odf-hidden');
                    });

                    // Next fnc in queue
                    next();
                });
            // Remove data-waiting attribute
            $('#page').removeClass('waiting').removeAttr('data-waiting');
            Odigeo.trigger('loading:hide');

            // Enable scrolling
            $el.off(Odigeo.Events.touchmove);
        };

        return {
            showLoading: show,
            hideLoading: hide,
        };
    };
}());
